import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "src/context";
import { useToast } from "src/components/Toast";
import { validEmail } from "src/utils";
import { EmailForm } from "./EmailForm";
import { SubmitSuccess } from "./SubmitSuccess";
import {
  Container,
  LogoContainer,
  BackgroundGradient,
  CenteredContainer,
  Title,
  SubTitle,
  SubTitleEmail,
} from "./LoginPage.styles";
import { Footer } from "./Footer";
import { Logo } from "src/components/Logo";
import { usePageView } from "src/hooks/usePageView";

export default () => {
  const [inputValue, setInputValue] = useState("");
  const [showError, setShowError] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const authObject = useAuth();
  const location = useLocation();
  const { setPendingToast } = useToast();
  usePageView("Login");

  useEffect(() => {
    if (
      location.state?.errorCode &&
      location.state.errorCode === "auth/invalid-action-code"
    ) {
      setPendingToast(
        "The magic link has expired. Please sign in again.",
        "error",
      );
    }
  }, [location.state]);

  const createMagicLink = () => {
    setLoading(true);
    const trimmedEmail = inputValue.trim();
    authObject
      .createMagicLink(trimmedEmail)
      .then(() => {
        console.log("Magic Link created");
        console.log(trimmedEmail);
        window.localStorage.setItem("emailForSignIn", trimmedEmail);
        setSubmitSuccess(true);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Magic Link ERROR :: ", error);
        setShowError(true);
        setLoading(false);
      });
  };
  const titleText = submitSuccess ? "Check your Inbox" : "Welcome to PorchPass";
  const subTitleText = submitSuccess ? (
    <>
      A magic link has been sent to <SubTitleEmail>{inputValue}</SubTitleEmail>
    </>
  ) : (
    "To get started, please sign in"
  );
  return (
    <Container>
      <BackgroundGradient />
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <CenteredContainer>
        <Title>{titleText}</Title>
        <SubTitle>{subTitleText}</SubTitle>
        {submitSuccess ? (
          <SubmitSuccess resendMagicLink={createMagicLink} />
        ) : (
          <EmailForm
            value={inputValue}
            showError={showError}
            onChange={(evt) => setInputValue(evt.target.value)}
            onFocus={() => setShowError(false)}
            onBlur={(evt) => {
              const trimmedValue = evt.target.value.trim();
              setInputValue(trimmedValue);
              setShowError(!validEmail(trimmedValue));
            }}
            onSubmit={() => !showError && createMagicLink()}
            loading={loading}
          />
        )}
      </CenteredContainer>
      <Footer />
    </Container>
  );
};
